export const LOGIN_REQ = "LOGIN_REQ";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const LOGOUT_REQ = "LOGOUT_REQ";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";

export const SAVE_TO_LOCAL = "SAVE_TO_LOCAL";
export const CLEAR_FROM_LOCAL = "CLEAR_FROM_LOCAL";

export const GETCOMPANIES_REQ = "GETCOMPANIES_REQ";
export const GETCOMPANIES_RESPONSE = "GETCOMPANIES_RESPONSE";

export const GETCOMPANY_REQ = "GETCOMPANY_REQ";
export const GETCOMPANY_RESPONSE = "GETCOMPANY_RESPONSE";

export const GETCOMPANYUSER_REQ = "GETCOMPANYUSER_REQ";
export const GETCOMPANYUSER_RESPONSE = "GETCOMPANYUSER_RESPONSE";

export const GETCOMPANYUSERSTAT_REQ = "GETCOMPANYUSERSTAT_REQ";
export const GETCOMPANYUSERSTAT_RESPONSE = "GETCOMPANYUSERSTAT_RESPONSE";

export const GETSUBSCRIPTIONS_REQ = "GETSUBSCRIPTIONS_REQ";
export const GETSUBSCRIPTIONS_RESPONSE = "GETSUBSCRIPTIONS_RESPONSE";
export const GETSUBSCRIPTION_ITEMS_REQ = "GETSUBSCRIPTION_ITEMS_REQ";
export const GETSUBSCRIPTION_ITEMS_RESPONSE = "GETSUBSCRIPTION_ITEMS_RESPONSE";

export const GETUSAGE_REQ = "GETUSAGE_REQ";
export const GETUSAGE_RESPONSE = "GETUSAGE_RESPONSE";

export const GETMODULES_REQ = "GETMODULES_REQ";
export const GETMODULES_RESPONSE = "GETMODULES_RESPONSE";

export const GETCOWORKERS_REQ = "GETCOWORKERS_REQ";
export const GETCOWORKERS_RESPONSE = "GETCOWORKERS_RESPONSE";

export const GETACTIVITY_REQ = "GETACTIVITY_REQ";
export const GETACTIVITY_RESPONSE = "GETACTIVITY_RESPONSE";

export const TOGGLECOMPANY_REQ = "TOGGLECOMPANY_REQ";
export const TOGGLECOMPANY_RESPONSE = "TOGGLECOMPANY_RESPONSE";

export const GETALLMODULES_REQ = "GETALLMODULES_REQ";
export const GETALLMODULES_RESPONSE = "GETALLMODULES_RESPONSE";

export const API_ERROR = "API_ERROR";

export const CREATECOMPANY_REQ = "CREATECOMPANY_REQ";
export const CREATECOMPANY_RESPONSE = "CREATECOMPANY_RESPONSE";

export const EDITCOMPANY_REQ = "EDITCOMPANY_REQ";
export const EDITCOMPANY_RESPONSE = "EDITCOMPANY_RESPONSE";

export const UPDATEMODULES_REQ = "UPDATEMODULES_REQ";
export const UPDATEMODULES_RESPONSE = "UPDATEMODULES_RESPONSE";

export const RESET_STATE = "RESET_STATE";

export const TOGGLEUSER_REQ = "TOGGLEUSER_REQ";
export const TOGGLEUSER_RESPONSE = "TOGGLEUSER_RESPONSE";

export const LOGINASUSER_REQ = "LOGINASUSER_REQ";
export const LOGINASUSER_RESPONSE = "LOGINASUSER_RESPONSE";

export const TOGGLECOWORKER_REQ = "TOGGLECOWORKER_REQ";
export const TOGGLECOWORKER_RESPONSE = "TOGGLECOWORKER_RESPONSE";

export const DELETECOWORKER_REQ = "DELETECOWORKER_REQ";
export const DELETECOWORKER_RESPONSE = "DELETECOWORKER_RESPONSE";

export const RESETCOWORKERPWD_REQ = "RESETCOWORKERPWD_REQ";
export const RESETCOWORKERPWD_RESPONSE = "RESETCOWORKERPWD_RESPONSE";

export const CREATECOWORKER_REQ = "CREATECOWORKER_REQ";
export const CREATECOWORKER_RESPONSE = "CREATECOWORKER_RESPONSE";

export const EDITCOWORKER_REQ = "EDITCOWORKER_REQ";
export const EDITCOWORKER_RESPONSE = "EDITCOWORKER_RESPONSE";

export const GETCOMPANYPOLICY_REQ = "GETCOMPANYPOLICY_REQ";
export const GETCOMPANYPOLICY_RESPONSE = "GETCOMPANYPOLICY_RESPONSE";

export const EDITCOMPANYPOLICY_REQ = "EDITCOMPANYPOLICY_REQ";
export const EDITCOMPANYPOLICY_RESPONSE = "EDITCOMPANYPOLICY_RESPONSE";

export const GETCOWORKER_REQ = "GETCOWORKER_REQ";
export const GETCOWORKER_RESPONSE = "GETCOWORKER_RESPONSE";

export const COWORKERCOMPANY_REQ = "COWORKERCOMPANY_REQ";
export const COWORKERCOMPANY_RESPONSE = "COWORKERCOMPANY_RESPONSE";

export const RESET2FA_REQ = "RESET2FA_REQ";
export const RESET2FA_RESPONSE = "RESET2FA_RESPONSE";

export const GETINDUSTRY_REQ = "GETINDUSTRY_REQ";
export const GETINDUSTRY_RESPONSE = "GETINDUSTRY_RESPONSE";

export const GETREGION_REQ = "GETREGION_REQ";
export const GETREGION_RESPONSE = "GETREGION_RESPONSE";

export const GETNOTES_REQ = "GETNOTES_REQ";
export const GETNOTES_RESPONSE = "GETNOTES_RESPONSE";

export const SAVENOTE_REQ = "SAVENOTE_REQ";
export const SAVENOTE_RESPONSE = "SAVENOTE_RESPONSE";

export const EDITNOTE_REQ = "EDITNOTE_REQ";
export const EDITNOTE_RESPONSE = "EDITNOTE_RESPONSE";

export const DELETENOTE_REQ = "DELETENOTE_REQ";
export const DELETENOTE_RESPONSE = "DELETENOTE_RESPONSE";

export const GETINTEGRATIONS_REQ = "GETINTEGRATIONS_REQ";
export const GETINTEGRATIONS_RESPONSE = "GETINTEGRATIONS_RESPONSE";

export const GETCREDENTIALS_REQ = "GETCREDENTIALS_REQ";
export const GETCREDENTIALS_RESPONSE = "GETCREDENTIALS_RESPONSE";

export const GETCREDENTIAL_REQ = "GETCREDENTIAL_REQ";
export const GETCREDENTIAL_RESPONSE = "GETCREDENTIAL_RESPONSE";

export const EDITCREDENTIAL_REQ = "EDITCREDENTIAL_REQ";
export const EDITCREDENTIAL_RESPONSE = "EDITCREDENTIAL_RESPONSE";

export const DELETECREDENTIAL_REQ = "DELETECREDENTIAL_REQ";
export const DELETECREDENTIAL_RESPONSE = "DELETECREDENTIAL_RESPONSE";

export const ADDCREDENTIAL_REQ = "ADDCREDENTIAL_REQ";
export const ADDCREDENTIAL_RESPONSE = "ADDCREDENTIAL_RESPONSE";

export const GETCOMPANYSTAT_REQ = "GETCOMPANYSTAT_REQ";
export const GETCOMPANYSTAT_RESPONSE = "GETCOMPANYSTAT_RESPONSE";

export const GETCOWORKERCOMPANIES_REQ = "GETCOWORKERCOMPANIES_REQ";
export const GETCOWORKERCOMPANIES_RESPONSE = "GETCOWORKERCOMPANIES_RESPONSE";

export const GETMIGRATION_REQ = "GETMIGRATION_REQ";
export const GETMIGRATION_RESPONSE = "GETMIGRATION_RESPONSE";

export const GETMIGRATIONDETAILS_REQ = "GETMIGRATIONDETAILS_REQ";
export const GETMIGRATIONDETAILS_RESPONSE = "GETMIGRATIONDETAILS_RESPONSE";

export const GETOPPOSITEENVREGION_REQ = "GETOPPOSITEENVREGION_REQ";
export const GETOPPOSITEENVREGION_RESPONSE = "GETOPPOSITEENVREGION_RESPONSE";

export const GETMIGRATIONDEFAULTOBJECT_REQ = "GETMIGRATIONDEFAULTOBJECT_REQ";
export const GETMIGRATIONDEFAULTOBJECT_RESPONSE = "GETMIGRATIONDEFAULTOBJECT_RESPONSE";

export const GETMIGRATIONOBJECTVALIDATE_REQ = "GETMIGRATIONOBJECTVALIDATE_REQ";
export const GETMIGRATIONOBJECTVALIDATE_RESPONSE = "GETMIGRATIONOBJECTVALIDATE_RESPONSE";

export const GETMIGRATIONSTATUSLIST_REQ = "GETMIGRATIONSTATUSLIST_REQ";
export const GETMIGRATIONSTATUSLIST_RESPONSE = "GETMIGRATIONSTATUSLIST_RESPONSE";

export const GETMIGRATIONSTART_REQ = "GETMIGRATIONSTART_REQ";
export const GETMIGRATIONSTART_RESPONSE = "GETMIGRATIONSTART_RESPONSE";
export const GETCOMPANYINVOICE_REQ = "GETCOMPANYINVOICE_REQ";
export const GETCOMPANYINVOICE_RESPONSE = "GETCOMPANYINVOICE_RESPONSE";

export const TOGGLESUBSCRIPTION_REQ = "TOGGLESUBSCRIPTION_REQ";
export const TOGGLESUBSCRIPTION_RESPONSE = "TOGGLESUBSCRIPTION_RESPONSE";


export const SYNCSUBSCRIPTION_REQ = "SYNCSUBSCRIPTION_REQ";
export const SYNCSUBSCRIPTION_RESPONSE = "SYNCSUBSCRIPTION_RESPONSE";

export const EDITSUBSCRIPTION_REQ = "EDITSUBSCRIPTION_REQ";
export const EDITSUBSCRIPTION_RESPONSE = "EDITSUBSCRIPTION_RESPONSE";

export const CREATESUBSCRIPTION_REQ = "CREATESUBSCRIPTION_REQ";
export const CREATESUBSCRIPTION_RESPONSE = "CREATESUBSCRIPTION_RESPONSE";

export const APIKEYVALIDATION_REQ = "APIKEYVALIDATION_REQ";
export const APIKEYVALIDATION_RESPONSE = "APIKEYVALIDATION_RESPONSE";

export const GETMODULECOUNT_REQ = "GETMODULECOUNT_REQ";
export const GETMODULECOUNT_RESPONSE = "GETMODULECOUNT_RESPONSE";

export const SETMODULECOUNT_REQ = "SETMODULECOUNT_REQ";

export const GET_COMPANY_POLICY_FIELDS_REQ = "GET_COMPANY_POLICY_FIELDS_REQ";
export const GET_COMPANY_POLICY_FIELDS_RESPONSE = 'GET_COMPANY_POLICY_FIELDS_RESPONSE'

export const GET_COMPANY_ZUPER_PAY_DETAILS_REQ = "GET_COMPANY_ZUPER_PAY_DETAILS_REQ";
export const GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE = 'GET_COMPANY_ZUPER_PAY_DETAILS_RESPONSE'

export const EDIT_ZUPER_PAY_REQ = "EDIT_ZUPER_PAY_REQ";
export const EDIT_ZUPER_PAY_RESPONSE = "EDIT_ZUPER_PAY_RESPONSE";


export const GET_WORK_BUILDER_NODE_FILTERS_REQ = "GET_WORK_BUILDER_NODE_FILTERS_REQ";
export const GET_WORK_BUILDER_NODE_FILTERS_RESP = "GET_WORK_BUILDER_NODE_FILTERS_RESP";

// Zuper Connect
export const GET_CONNECT_PROVIDER_REQ = "GET_CONNECT_PROVIDER_REQ";
export const GET_CONNECT_PROVIDER_RES = "GET_CONNECT_PROVIDER_RES";

export const GET_CONNECT_AGENT_REQ = "GET_CONNECT_AGENT_REQ";
export const GET_CONNECT_AGENT_RES = "GET_CONNECT_AGENT_RES";

export const ADD_CONNECT_PROVIDER_REQ = "ADD_CONNECT_PROVIDER_REQ";
export const ADD_CONNECT_PROVIDER_RES = "ADD_CONNECT_PROVIDER_RES";

export const ADD_CONNECT_AGENT_REQ = "ADD_CONNECT_AGENT_REQ";
export const ADD_CONNECT_AGENT_RES = "ADD_CONNECT_AGENT_RES";